// External Dependencies
import Marionette from 'backbone.marionette';
import Backbone from 'backbone';

// Internal Dependencies - screens/views/templates
import  suspendedCompositeView  from '../../../../templates/CCM/Suspended/suspendedCompositeView';
import SuspendedItemView from './SuspendedItemView';

// Internal Dependencies - models/collections

export default Marionette.CompositeView.extend({

	className: 'suspended-composite-view',

	childViewContainer: '.patient-list-container',

	childView: SuspendedItemView,

	events: {
		'click .clear-search': 'resetSearch',
	},

	initialize: function() {
		this.channel = Backbone.Radio.channel( 'AppChannel' );
		this.app = this.channel.request( 'app' );
		this.currentPage = 0;
		this.pageSize = 20;

		let searchObj = {
			placeholder: 'Search first name, last name, or PID'
		};

		this.channel.trigger( 'show:search', searchObj, this.collection );

		this.app.ccm_controller.getSuspendedList();
		this.collection.loading = true;
		this.listenTo( this.channel, 'set:patientList', this.setSuspendedPatients );
		this.listenTo( this.channel, 'reset:currentPage', this.resetCurrentPage );
		this.listenTo( this.channel, 'rerender', this.render );
		this.listenTo( this.collection, 'update', this.render );
		this.listenTo( this.channel, 'set:selectedProviderId', this.getSuspendedPatients );
		this.listenTo( this.channel, 'set:selectedProgramType', this.getSuspendedPatients );

		this.channel.reply( 'currentPage', () => {
			return this.currentPage;
		});
		this.channel.reply( 'pageSize', () => {
			return this.pageSize;
		});
		$('.content-container').addClass('widen');
	},

	getTemplate: function() {
		return suspendedCompositeView( this.collection );
	},

	getSuspendedPatients: function() {
		this.collection.loading = true;
		this.render();
		this.app.ccm_controller.getSuspendedList( 'reset:currentPage' );
	},

	setSuspendedPatients: function( cashedPatientList = null ) {
		this.collection.loading = false;
		this.render();
		this.collection.reset();
		let suspendedList = this.app.ccm_controller.patientList;
		this.collection.renderNoResults = suspendedList && suspendedList.length ? false : true;
		this.collection.isApcm = this.app.controller.isApcm;
		let search = this.app.ccm_controller.searchInput;
		this.collection.search = search ? search.substring( search.lastIndexOf("=") + 1 ) : '';
		this.collection.add( suspendedList );
		!suspendedList.length && this.render();
	},

	resetSearch: function() {
		this.channel.trigger( 'reset:search' );
	},

	resetCurrentPage: function() {
		this.currentPage = 0;
		this.app.ccm_controller.patients.currentPage = this.currentPage;
        this.channel.trigger( 'reset:totals' );
	},

	onDestroy: function() {
		this.channel.trigger( 'remove:search' );
		this.app.ccm_controller.clearValue( 'suspended' );
		this.app.ccm_controller.clearValue( 'sortedBy' );
		$('.content-container').removeClass('widen');
	},

});
